import orderBy from "lodash/orderBy";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";
import * as Table from "reactabular-table";
import { Flex, Text } from "rebass";
import { bindActionCreators, compose } from "redux";
import * as sort from "sortabular";
import {
  PvCaret,
  PvLinkGreen,
  PvLinkGreenCap,
  PvInfo,
  PvLinkRed,
  PvLinkRedCap,
} from "styles/CustomComponents";
import { PvCourseBadge } from "../../components/PvBadge";
import { resolve } from "table-resolver";
import { getApplicantAction } from "ducks/workItem";
import {
  IndependentDrivingStatusBadge,
  IndependentHandlingPermStatusBadge,
  PersonTransportPermStatusBadge,
} from "../applicant/StatusBadges";
import { getPersonTransportPermState, PERSON_TRANSPORT_PERM_STATES } from "../applicant/getPersonTransportPermState";

class StatusDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};

    const togglePermissionLegend = () =>
      this.setState({ showPermissionLegend: !this.state.showPermissionLegend });

    const sortable = sort.sort({
      getSortingColumns,
      onSort: (selectedColumn) => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn,
          }),
        });
      },
      strategy: sort.strategies.byProperty,
    });

    const columns = [
      {
        property: "lastName",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="app.name" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        cell: {
          formatters: [
            (_value, props) => {
              return (
                <Text>
                  {props.rowData.applicantStatus === "ACTIVE" && (
                    <span>
                      <PvLinkGreen
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.getApplicant(
                            props.rowData.entityId,
                            props.rowData.course
                          );
                        }}
                      >
                        {props.rowData.lastName}
                      </PvLinkGreen>
                      &nbsp;
                      <PvLinkGreenCap
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.getApplicant(
                            props.rowData.entityId,
                            props.rowData.course
                          );
                        }}
                      >
                        {props.rowData.firstNames}
                      </PvLinkGreenCap>
                    </span>
                  )}
                  {props.rowData.applicantStatus !== "ACTIVE" && (
                    <span>
                      <PvLinkRed
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.getApplicant(
                            props.rowData.entityId,
                            props.rowData.course
                          );
                        }}
                      >
                        {props.rowData.lastName}
                      </PvLinkRed>
                      &nbsp;
                      <PvLinkRedCap
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.getApplicant(
                            props.rowData.entityId,
                            props.rowData.course
                          );
                        }}
                      >
                        {props.rowData.firstNames}
                      </PvLinkRedCap>
                    </span>
                  )}
                </Text>
              );
            },
          ],
        },
        visible: true,
      },
      {
        property: "completedCount",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="app.completed" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        props: {
          style: {
            width: "8em",
          },
        },
        visible: true,
      },
      {
        property: "missingCount",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="app.missing" />
              <PvCaret />
            </Flex>
          ),
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty,
            }),
          ],
        },
        props: {
          style: {
            width: "7em",
          },
        },
        visible: true,
      },
      {
        property: "course",
        header: {
          label: <Translate value="datatable.course" />,
        },
        props: {
          style: {
            width: "8em",
          },
        },
        cell: {
          formatters: [(course) => <PvCourseBadge course={course} />],
        },
        visible: true,
      },
      {
        property: "perms",
        header: {
          label: (
            <Flex
              alignItems="center"
              justifyContent="space-between"
              title={I18n.t("datatable.permission_status_legend")}
              onClick={togglePermissionLegend}
            >
              <Translate value="datatable.permission_status" />
              <PvInfo />
            </Flex>
          ),
        },
        props: {
          style: {
            textAlign: "center",
            width: "9em",
          },
        },
        cell: {
          formatters: [
            (_value, props) => {
              return (
                <Flex>
                  {props.rowData.course.personTransportCourse && (
                    <PersonTransportPermStatusBadge
                    state={getPersonTransportPermState(
                      props.rowData.eligibleForPersonTransport,
                      props.rowData.personTransportPerm,
                      props.rowData.personTransportPermApproved
                    )}
                    hideLabel
                  />
                  )}
                  {props.rowData.course.proCourse && (
                    <React.Fragment>
                      <IndependentHandlingPermStatusBadge
                        independentHandlingPerm={
                          props.rowData.independentHandlingPerm
                        }
                        hideLabel
                      />
                      <IndependentDrivingStatusBadge
                        lessonsCompleted={
                          props.rowData.independentDrivingLessonsCompleted
                        }
                        hideLabel
                      />
                    </React.Fragment>
                  )}
                </Flex>
              );
            },
          ],
        },
        visible: this.props.tableType === "THEORY_STATUS",
      },
    ];

    this.state = {
      // Default sorting
      sortingColumns: {
        lastName: {
          direction: "asc",
          position: 0,
        },
      },
      columns,
      rows: resolve({ columns })(this.props.rows || []),
      showPermissionLegend: false,
    };
  }

  componentWillReceiveProps(props) {
    this.setState({ rows: props.rows });
  }

  render() {
    const { stylingRenderers, rowKey } = this.props;

    const { sortingColumns, columns, rows, showPermissionLegend } = this.state;
    const visibleCols = columns.filter((column) => column.visible);
    const finalRows = compose(
      sort.sorter({
        columns: visibleCols,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty,
      })
    )(rows);

    return (
      <React.Fragment>
        {showPermissionLegend && (
          <Flex flexWrap="wrap">
            <React.Fragment>
              <PersonTransportPermStatusBadge
                state={
                  PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_NOT_ELIGIBLE
                }
              />
              <PersonTransportPermStatusBadge
                state={
                  PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_ELIGIBLE
                }
              />
              <PersonTransportPermStatusBadge
                state={
                  PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_RECOMENDED
                }
              />
              <PersonTransportPermStatusBadge
                state={
                  PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_APPROVED
                }
              />
            </React.Fragment>
            <React.Fragment>
              <IndependentHandlingPermStatusBadge
                independentHandlingPerm={false}
              />
              <IndependentHandlingPermStatusBadge
                independentHandlingPerm={true}
              />
              <IndependentDrivingStatusBadge lessonsCompleted={false} />
              <IndependentDrivingStatusBadge lessonsCompleted={true} />
            </React.Fragment>
          </Flex>
        )}
        <Table.Provider renderers={stylingRenderers} columns={visibleCols}>
          <Table.Header />
          <Table.Body rows={finalRows} rowKey={rowKey || "entityId"} />
        </Table.Provider>
      </React.Fragment>
    );
  }
}

StatusDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  getApplicant: PropTypes.func,
  highlightFn: PropTypes.func,
  stylingRenderers: PropTypes.object,
  filters: PropTypes.object,
  rowKey: PropTypes.string,
  tableType: PropTypes.string,
  showProColumns: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getApplicant: (id, course) => getApplicantAction(id, course),
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(StatusDataTable);



// WEBPACK FOOTER //
// ./src/components/datatable/StatusDataTable.jsx